import React from "react";

type Props = {
  count: number;
  limit: number;
};

const colorClass = (count: number, limit: number) => {
  if (count > limit) return "text-red-500 font-medium";
  if (count > limit * 0.9) return "text-orange-400";
  return "text-gray-400";
};

const CharacterCounter = ({ count, limit }: Props) => (
  <p className={`text-right text-xs tabular-nums ${colorClass(count, limit)}`}>
    {count} / {limit}
  </p>
);

export default CharacterCounter;
